import { render, staticRenderFns } from "./DataPicker.vue?vue&type=template&id=22690c9a&scoped=true&"
import script from "./DataPicker.vue?vue&type=script&lang=js&"
export * from "./DataPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22690c9a",
  null
  
)

export default component.exports